import React, { useState } from "react";
import "./AccordionBullets.css";

interface Bullet {
  id: string;
  title: string;
  content: string;
}

interface AccordionBulletsProps {
  bullets: Bullet[];
  expanded?:boolean;
}

/**
 * Componente que muestra una lista de viñetas con un título (triángulo apuntando a la derecha).
 * Al hacer clic en el título, se expande para mostrar su contenido, girando el triángulo hacia abajo.
 */
export default function AccordionBullets({ bullets, expanded }: AccordionBulletsProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleToggle = (id: string) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  return (
    <ul className="accordionList">
      {bullets.map((bullet) => {
        const isExpanded = expanded?expanded: bullet.id === expandedId;
        //const isExpanded = true;
        return (
          <li key={bullet.id} className="accordionItem">
            {expanded!==undefined?
                <button
                    className="accordionHeaderGlosario"
                    onClick={() => handleToggle(bullet.id)}
                    aria-expanded={isExpanded}
                  >
                    <span className={`arrowIcon ${isExpanded ? "expanded" : ""}`} />
                    <span className="accordionTitle">{bullet.title}</span>
                  </button>
                  :
                <button
                    className="accordionHeader"
                    onClick={() => handleToggle(bullet.id)}
                    aria-expanded={isExpanded}
                  >
                    <span className={`arrowIcon ${isExpanded ? "expanded" : ""}`} />
                    <span className="accordionTitle">{bullet.title}</span>
                  </button>
            }
            
            
            {isExpanded && (
              <div className="accordionContent">
                
                {bullet.content}
                
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}